// extracted by mini-css-extract-plugin
export default {"container":"KWjPaelZgSRJql14_ks0"};